import React, { useCallback } from 'react';

import classnames from 'classnames';

import { PrimaryButton, TertiaryButton } from 'components/uiLibrary/LinkButton';
import Typography from 'components/uiLibrary/Typography';

import CommonTrans from 'components/Globals/CommonTrans';
import PriceRange from 'components/Paywall/PriceRange';

import { TP } from 'constants/index';

import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';

import { useTranslation } from 'src/i18n';

import classes from './PlanCard.module.scss';

const PlanCard = ({
  plan,
  onClick,
  canPurchase,
  canUpgrade,
  canDowngrade,
  isCurrentPlan,
  isRedirecting,
  isProcessing,
}) => {
  const { label, features, price, isMonthly, inlinePricing = false } = plan;
  const { t } = useTranslation('NS_APP_GLOBALS');
  const { isDesktop } = useDeviceTypeLayouts();

  const onClickHandler = useCallback(() => {
    if (isCurrentPlan || isRedirecting || isProcessing) {
      return;
    }

    onClick(plan);
  }, [onClick, plan, isCurrentPlan, isRedirecting, isProcessing]);

  return (
    <div className={classnames(classes.root, { [classes.inline]: inlinePricing })} onClick={onClickHandler}>
      <div className={classes.label}>
        <Typography size={13} weight="bold">
          {t(label)}
        </Typography>
        {!isDesktop && <PriceRange price={price} isMonthly={isMonthly} />}
      </div>
      <div className={classes.features}>
        {features && (
          <CommonTrans
            ns="NS_APP_GLOBALS"
            i18nKey={features}
            components={{
              ul: <ul className={classes.list} />,
              li: <Typography variant="li" size={isDesktop ? 13 : 12} className={classes.list__item} />,
              p: <Typography variant="p" size={isDesktop ? 13 : 12} />,
            }}
          />
        )}
      </div>
      <div className={classes.price}>
        <div className={classnames(classes.priceWrapper, { [classes.inline]: inlinePricing })}>
          {isDesktop && (
            <div>
              <PriceRange price={price} isMonthly={isMonthly} />
            </div>
          )}
          <div className={classes.cta}>
            {!isCurrentPlan && (canPurchase || canUpgrade) ? (
              <PrimaryButton
                size="small"
                shape="rectangle"
                onClick={() => onClick(plan)}
                disabled={isRedirecting}
                loading={isProcessing}
              >
                {canUpgrade ? t(`${TP}.AS_SUBSCRIPTIONS_UPGRADE`) : t(`${TP}.FN_PROCEED`)}
              </PrimaryButton>
            ) : (
              <TertiaryButton
                size="small"
                shape="rectangle"
                onClick={() => onClick(plan)}
                disabled={isCurrentPlan || isRedirecting}
                loading={isProcessing}
              >
                {canDowngrade ? t(`${TP}.FN_DOWNGRADE`) : t('CURRENT_PLAN')}
              </TertiaryButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
